import React from 'react';
import { Search } from 'lucide-react';

export const ProductPreview = () => {
  return (
    <section className="pt-0 pb-12 px-6 sm:px-10 lg:px-16">
      {/* Browser mockup with tabs */}
      <div className="max-w-5xl mx-auto">
        <div className="rounded-xl shadow-2xl overflow-hidden border border-border/50 bg-white">
          {/* Browser chrome */}
          <div className="bg-gray-100 px-4 py-3 flex items-center gap-2 border-b border-border/30">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-red-400" />
              <div className="w-3 h-3 rounded-full bg-yellow-400" />
              <div className="w-3 h-3 rounded-full bg-green-400" />
            </div>
            <div className="flex-1 flex justify-center">
              <div className="bg-white rounded-md px-4 py-1 text-sm text-muted-foreground">
                mindfull.app
              </div>
            </div>
          </div>
          
          {/* App content mockup */}
          <div className="bg-[#faf8f5] p-6">
            {/* View tabs */}
            <div className="flex gap-2 mb-6 justify-center">
              <button className="px-4 py-2 bg-[#ff5c35]/10 text-[#ff5c35] rounded-full font-medium text-sm">
                Discover
              </button>
              <button className="px-4 py-2 text-muted-foreground hover:bg-muted/50 rounded-full text-sm transition-colors">
                Create
              </button>
            </div>
            
            {/* Search bar */}
            <div className="max-w-md mx-auto mb-6">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-white rounded-lg border border-border/50 shadow-sm">
                <Search className="w-4 h-4 text-muted-foreground/50" />
                <span className="text-muted-foreground/50 text-sm">Search mindfull</span>
              </div>
            </div>

            {/* Filter pills */}
            <div className="flex gap-2 justify-center mb-6 flex-wrap">
              {['Photos', 'Videos', 'Notes', 'Text', 'Docs', 'Links'].map((filter) => (
                <span 
                  key={filter} 
                  className="px-3 py-1 text-xs rounded-full bg-white border border-border/50 text-muted-foreground"
                >
                  {filter}
                </span>
              ))}
            </div>
            
            {/* Masonry grid preview */}
            <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
              {/* Sticky note */}
              <div className="bg-yellow-100 rounded-lg p-3 aspect-square flex items-start">
                <div className="text-xs text-yellow-800/70 font-medium">Meeting notes...</div>
              </div>
              {/* Image placeholder */}
              <div className="bg-gradient-to-br from-sky-100 to-sky-200 rounded-lg aspect-[3/4]" />
              {/* Link card */}
              <div className="bg-white rounded-lg p-3 aspect-square border border-border/30 shadow-sm">
                <div className="h-2 bg-muted rounded w-3/4 mb-2" />
                <div className="h-1.5 bg-muted/50 rounded w-full mb-1" />
                <div className="h-1.5 bg-muted/50 rounded w-2/3" />
              </div>
              {/* Image */}
              <div className="bg-gradient-to-br from-rose-100 to-rose-200 rounded-lg aspect-[4/3]" />
              {/* Document */}
              <div className="bg-white rounded-lg p-3 aspect-square border border-border/30 shadow-sm col-span-1">
                <div className="h-1.5 bg-muted rounded w-full mb-1.5" />
                <div className="h-1.5 bg-muted/50 rounded w-full mb-1" />
                <div className="h-1.5 bg-muted/50 rounded w-full mb-1" />
                <div className="h-1.5 bg-muted/50 rounded w-3/4" />
              </div>
              {/* Image */}
              <div className="bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-lg aspect-square" />
              {/* Sticky */}
              <div className="bg-pink-100 rounded-lg p-3 aspect-[4/3] flex items-start">
                <div className="text-xs text-pink-800/70 font-medium">Ideas for...</div>
              </div>
              {/* Image */}
              <div className="bg-gradient-to-br from-violet-100 to-violet-200 rounded-lg aspect-square" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
